var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertComment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8017_13632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 64.3552C0 25.5569 23.5174 0 64.2427 0C104.975 0 128 24.8392 128 63.6447C128 102.45 104.968 128 64.2427 128C23.5174 128 0 103.154 0 64.3552Z",
    fill: "#EAEFF7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8017_13632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 43C50.7438 43 40 51.7281 40 62.5C40 67.15 42.0063 71.4063 45.3438 74.7531C44.1719 79.4781 40.2531 83.6875 40.2063 83.7344C40 83.95 39.9438 84.2688 40.0656 84.55C40.1875 84.8313 40.45 85 40.75 85C46.9656 85 51.625 82.0187 53.9313 80.1813C56.9969 81.3344 60.4 82 64 82C77.2562 82 88 73.2719 88 62.5C88 51.7281 77.2562 43 64 43Z",
    fill: "#2C60AE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8017_13632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8017_13632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(40 40)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertComment);
export default __webpack_public_path__ + "static/media/alert-comment.eadd50dd06c57ea3c76c7fa07f4eb83b.svg";
export { ForwardRef as ReactComponent };